import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Role, RoleData} from "@core/services/backend/common/interface/roles";
import {RolesApi} from "@core/services/backend/common/api/roles.api";


@Injectable()
export class RolesService extends RoleData {

    constructor(private api: RolesApi) {
        super();
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        return this.api.list(search, pageNumber, pageSize, orderBy);
    }

    get(id: number, cloudId: number): Observable<Role> {
        return this.api.get(id, cloudId);
    }

    // tslint:disable-next-line:no-shadowed-variable
    create(Group: any): Observable<Role> {
        return this.api.add(Group);
    }

    // tslint:disable-next-line:no-shadowed-variable
    update(Group: any): Observable<Role> {
        return this.api.update(Group);
    }

    delete(Group: any): Observable<Role> {
        return this.api.delete(Group);
    }

}
